import { useEffect } from 'react';
import { useStore } from '@nanostores/react';

import { $loggedIn } from '../../skilljar/stores/user';
import { trackViewedResource } from '../../skilljar/stores/viewed-resources';

export const TrackViewedResource = ({
  resourceId,
  resourceType,
}: {
  resourceId: string;
  resourceType: string;
}) => {
  const loggedIn = useStore($loggedIn);

  if (loggedIn && resourceId) {
    trackViewedResource(resourceId);
  }

  useEffect(() => {
    if (resourceId) {
      window.klaviyo?.track('Viewed Academy resource', {
        resourceType: resourceType,
        resourceId: resourceId,
        url: `${window.location.origin}${window.location.pathname}`,
      });
    }
  }, [resourceId, resourceType]);

  return null;
};
